import { render, staticRenderFns } from "./PowerHistory.vue?vue&type=template&id=2ae6cffc"
import script from "./PowerHistory.vue?vue&type=script&lang=js"
export * from "./PowerHistory.vue?vue&type=script&lang=js"
import style0 from "./PowerHistory.vue?vue&type=style&index=0&id=2ae6cffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports